import { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { desktopMarginsCutoff } from "../../styleConstants";
import HowVerificationWorksSlideIn from "./HowVerificationWorksSlideIn/HowVerificationWorksSlideIn";
import HowPetitionsMatterSlideIn from "./HowPetitionsMatterSlideIn/HowPetitionsMatterSlideIn";
import HomeButtonPanel from "./HomeButtonPanel/HomeButtonPanel";

const Wrapper = styled.div`
  padding-top: 24px;
  padding-bottom: 16px;

  @media screen and (min-width: ${desktopMarginsCutoff}px) {
    padding-top: 48px;
    padding-bottom: 24px;
  }
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: 600;

  @media screen and (min-width: ${desktopMarginsCutoff}px) {
    font-size: 28px;
  }
`;

const SubTitle = styled.div`
  margin-top: 6px;
  font-size: 18px;

  @media screen and (min-width: ${desktopMarginsCutoff}px) {
    margin-top: 0px;
    font-size: 26px;
  }
`;

const TextSection = styled.div`
  margin-top: 36px;
  margin-bottom: 18px;
  color: rgba(0, 0, 0, 0.55);

  max-width: 680px;
  @media screen and (min-width: ${desktopMarginsCutoff}px) {
    font-size: 18px;
  }
`;

const InfoLink = styled.div`
  margin-top: 2px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;

  @media screen and (min-width: ${desktopMarginsCutoff}px) {
    font-size: 16px;
  }
`;

const ButtonPanelWrapper = styled.div`
  margin-top: 84px;
`;

const PoliciesStatement = styled.div`
  margin-top: 10px;
  color: rgba(0, 0, 0, 0.4);
  font-size: 14px;
`;

const Home = () => {
  const [verificationSlideOpen, setVerificationSlideOpen] = useState(false);
  const [petitionsSlideOpen, setPetitionsSlideOpen] = useState(false);

  return (
    <>
      {verificationSlideOpen && (
        <HowVerificationWorksSlideIn
          close={() => {
            setVerificationSlideOpen(false);
          }}
        />
      )}
      {petitionsSlideOpen && (
        <HowPetitionsMatterSlideIn
          close={() => {
            setPetitionsSlideOpen(false);
          }}
        />
      )}
      <Wrapper>
        <Title>Verified Voice</Title>
        <SubTitle>
          Support or oppose petitions as a verified Florida voter.
        </SubTitle>
        <TextSection>
          We can verify your Florida voter registration with a simple contact
          match — so petition results reflect real people, not bots or
          duplicates.
        </TextSection>
        <InfoLink
          onClick={() => {
            setVerificationSlideOpen(true);
          }}
        >
          How voter verification works
        </InfoLink>
        <InfoLink
          onClick={() => {
            setPetitionsSlideOpen(true);
          }}
        >
          How Verified Voice petitions matter
        </InfoLink>
        <ButtonPanelWrapper>
          <HomeButtonPanel />
        </ButtonPanelWrapper>
        <PoliciesStatement>
          By browsing this website or engaging with our platform, you agree to
          our{" "}
          <Link
            to="/about/terms-of-service"
            target="_blank"
            style={{ color: "rgba(0, 0, 0, 0.4)" }}
          >
            Terms of Service
          </Link>{" "}
          and{" "}
          <Link
            to="/about/privacy-policy"
            target="_blank"
            style={{ color: "rgba(0, 0, 0, 0.4)" }}
          >
            Privacy Policy
          </Link>
          .
        </PoliciesStatement>
      </Wrapper>
    </>
  );
};

export default Home;
